import { AlertSnackbar, isNil, Loader } from '@shared';
import { Stack } from '@mui/material';
import { currentVideoTime, getScreenshotByTime } from './Screenshots.utils';
import { ScreenshotsPropsType } from './Screenshots.types';
import { useState } from 'react';
import { API_ROUTES } from 'App';

const { REACT_APP_URL } = process.env;

export const Screenshots = (props: ScreenshotsPropsType) => {
  const { stream, screenshotsClock, progressPlayed } = props;
  const [isError, setIsError] = useState(false);

  if (!screenshotsClock.length) {
    return (
      <Stack mt={2} direction='row' justifyContent='center' alignItems='center'>
        No screenshots found for this stream.
      </Stack>
    );
  }

  if (isError) {
    return null;
  }

  const currentTime = currentVideoTime(
    stream.videoStartClock,
    stream.videoEndClock,
    progressPlayed
  );
  const currentScreenshot = getScreenshotByTime(screenshotsClock, currentTime);

  if (isNil(currentScreenshot)) {
    return <Loader />;
  }

  const src =
    REACT_APP_URL + API_ROUTES.apiV1AuditScreenshot(stream.streamHandle, currentScreenshot.append);

  return (
    <>
      <AlertSnackbar
        text={'Something went wrong with the screenshot'}
        open={isError}
        handleClose={() => setIsError(false)}
      />
      <img
        width='100%'
        src={src}
        alt='screenshot'
        onError={() => setIsError(true)}
        onLoad={() => setIsError(false)}
      />
    </>
  );
};
